export const TOLERANCE_GROUP_MAX = 39
export const DIMENSION_VALUE_MAX = 100

export const isInvalidValue = (value: number | null | undefined, minValue: number, maxValue: number): boolean => {
  if (value === null || value === undefined) {
    return true
  }
  if (Number.isNaN(value)) {
    return true
  }
  return value < minValue || value > maxValue
}

export const getToleranceValueLimits = (field: string): { minValue: number; maxValue: number } => {
  const isToleranceGroupId = field === 'toleranceGroupId'
  return {
    minValue: 0,
    maxValue: isToleranceGroupId ? TOLERANCE_GROUP_MAX : DIMENSION_VALUE_MAX,
  }
}

export const isInvalidToleranceValue = (value: number | null | undefined, field: string): boolean => {
  const { minValue, maxValue } = getToleranceValueLimits(field)
  return isInvalidValue(value, minValue, maxValue)
}
